"use strict";
module.exports = {
    entityModel: 'priceList',
    events: {
        PRICE_LIST_UPDATED: 'PRICE_LIST_UPDATED',
        PRICE_LIST_CREATED: 'PRICE_LIST_CREATED',
        PRICE_LIST_ACTIVATED: 'PRICE_LIST_ACTIVATED',
        PRICE_LIST_DEACTIVATED: 'PRICE_LIST_DEACTIVATED',
    },
    actions: {
        get: 'v1.priceList.get',
        list: 'v1.priceList.list',
        addArticle: 'v1.priceList.addArticle',
        addCustomerSubUnit: 'v1.priceList.addCustomerSubUnit',
        addSupplierCustomer: 'v1.priceList.addSupplierCustomer',
        removeSupplierCustomer: 'v1.priceList.removeSupplierCustomer',
        moveSupplierCustomer: 'v1.priceList.moveSupplierCustomer',
        writePriceList: 'v1.priceList.writePriceList',
        writePriceListForCustomer: 'v1.priceList.writePriceListForCustomer',
        writePriceListFast: 'v1.priceList.writePriceListFast',
        deactivate: 'v1.priceList.deactivate',
        activate: 'v1.priceList.activate',
        upsert: 'v1.priceList.upsert',
        upsertWhenEmpty: 'v1.priceList.upsertWhenEmpty',
        updateWhenEmpty: 'v1.priceList.updateWhenEmpty',
        update: 'v1.priceList.update',
    },
    customerTypes: {
        horeca: 'horeca',
        dvh: 'dvh',
        wholesale: 'wholesale',
        office: 'office',
        systembolaget: 'systembolaget',
        export: 'export',
        other: 'other',
    },
    priceTypes: {
        campaign: 'campaign',
        tender: 'tender',
        tenderCampaign: 'tenderCampaign',
    },
    discountAgreements: {},
    priceListEntries: {
        priceTypes: {
            campaign: 'campaign',
            tender: 'tender',
            tenderCampaign: 'tenderCampaign',
        },
    },
};
